import {EMPTY, expand, lastValueFrom, Observable, of, take} from "rxjs";
import {Versao} from "../../../domain/Versao";
import {Repository} from "typeorm";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {HttpClient} from "@angular/common/http";
import {SQLiteService} from "../../sqlite.service";
import {environment} from "../../../../environments/environment";

export class Download<T> {
  // abstract nome:string
  versaoLocal: Versao | null = null
  sentido = "Download"
  LIMIT = 20000
  baixados = 0
  versaoService: Repository<Versao> = LocalDataSource.getRepository(Versao)

  constructor(protected service: HttpClient,public nomeEntidade: string, public nomeTabela: string,  public classe: any, private sqlite: SQLiteService) {
  }

  async sinc(): Promise<number>{
    const regs = await lastValueFrom(this.service.get<T[]>(this.mountURL(this.versaoLocal)))
    console.log('resp', regs)
    if (regs?.length > 0) {
      const primeiro = regs[0] as any
      console.log(`baixados ${regs.length} ${this.nomeTabela} a partir de ${primeiro['updatedAt']}`)
      this.baixados += regs.length
      const ultimo = regs[regs.length - 1] as any
      if (this.versaoLocal == undefined) this.versaoLocal = new Versao()
      this.versaoLocal.nome = this.nomeTabela
      this.versaoLocal.versao = ultimo.updatedAt
      this.versaoLocal.id = ultimo.id //+'').padStart(10, '0')
      const transformados = await this.transformBeforeSave(regs)
      await this.save(transformados, this.versaoLocal)
    }
    return regs?.length
  }

  async save(transformados: any[], versaoLocal: Versao){
      await LocalDataSource.transaction(async e => {
          await e.save(this.classe, transformados)
          await e.save(Versao, versaoLocal)
      })
      await this.sqlite.saveToStore()
  }

  mountURL(v: Versao | null): string {
    return  `${environment.url}/api/${this.nomeTabela}/sync?limite=${this.LIMIT}` + (v == null ? '' : `&ultimaDataHora=${v.versao}&id=${v.id}`)
  }

  async transformBeforeSave(lista: any[]): Promise<T[]> {
    lista.forEach(i => delete i['updatedAt'])
    return lista
  }

  async checkSincronizacao(versoes: Versao[]) {
    const versaoServer = versoes.find(v => v.nome == this.nomeTabela)!!

    if (versaoServer == undefined || versaoServer.versao == undefined) return false
    console.log(this.nomeTabela)
    const versaoLocal = await this.versaoService.findOneBy({nome: this.nomeTabela})
    console.log('server', versaoServer)
    console.log('local', versaoLocal)
    const resp = versaoLocal?.versao == undefined || versaoLocal.versao != versaoServer.versao || versaoLocal.id != versaoServer.id
    this.versaoLocal = versaoLocal
    return resp
  }
}
